import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Typography, List, Collapse, ListItem, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Divider, DialogContentText } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IconArrowNarrowLeftDashed, IconCheck, IconChevronDown, IconChevronUp, IconCrown, IconPencil, IconX } from "@tabler/icons-react";
import { BeatLoader } from "react-spinners";
import PageContainer from "./Pagecontainer";
import ScheduleDemo from "./demo";
import Chart from 'chart.js/auto';
import Cookies from 'js-cookie';
const ViewDocuments = ({ Exportloader }) => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const projectid = params.get("id");
    const doctype = params.get("type");
    const token = params.get("token");
    const ProjectName= params.get("name");
    const [Openpopup, setOpenpopup] = useState(false);
    const userInfo1 = JSON.parse(sessionStorage.getItem('user-info'));

    const userInfo = async () => {
        try {
            const config = axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }
            const response = await axios.get('/apiV1/user-info/', config);
            console.log(response.data);
            if (response.status == 200) {
                sessionStorage.setItem("user-info", JSON.stringify(response.data))
                Cookies.set('user-info', JSON.stringify(response.data), {
                    expires: 1,
                    secure: true,
                    sameSite: 'Strict',
                });
            }
        } catch (error) {
            console.error('Error generating test:', error.response ? error.response.data : error.message);
        }
    }
    useEffect(() => {
        if (token) {
            sessionStorage.setItem("AdminToken", token)
            // const token = response.data.access;
            Cookies.set('AdminToken', token, {
                expires: 1,
                secure: true,         
                sameSite: 'Strict',
            });
            userInfo();
        }
    }, [token]);
    const [headings, setHeadings] = useState([]);
    const [docdata, setDocData] = useState();
    // console.log("Document Data:", docdata);
    
    const [loading, setLoading] = useState(false);
    const [openSections, setOpenSections] = useState({"business_overview": true});
    const [selectedIndex, setSelectedIndex] = useState("business_overview-business_summary");
    const [selectedData, setSelectedData] = useState('');
    const [promptChange, setPromptChange] = useState("");
    const [open, setOpen] = useState(false);
    const [loader, setloader] = useState(false)
    const [edit, setEdit] = useState(false)
    const [content, setContent] = useState(docdata);
    useEffect(() => {
        setContent(docdata);
    }, [docdata]);
    const toggleSection = (index) => {
        setOpenSections((prev) => ({
            [index]: !prev[index],
        }));
    };
    useEffect(() => {
        setLoading(Exportloader);
    }, [Exportloader]);
  const [setupdata,setsetupdata]=useState()
    const getSetupData=async()=>
    {
        try
        {
            const response = await axios.get('/apiV1/set-up/', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });
            if (response.status === 200) {
                setsetupdata(response.data)
            }
        }
        catch(err)
        {
            console.log(err?.response?.data?.message);
            
        }
    }
    useEffect(()=>
    {
        getSetupData()
    },[])
    const GetDocinfo = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/apiV1/get-document/?project_id=${projectid}&doc_type=${doctype}`);
            console.log("API Response:", response.data);
            if (response.status === 200  ) {
                if(doctype === 'doc_short'){
                    setDocData(response.data)
                }else{
                    const cleanedHTML = response.data.data
                     setDocData(cleanedHTML);
                }
                // const cleanedHTML = response.data
               
                setLoading(false)
                if (response.data.data && response.data.data) {
                    const dynamicHeadings = Object.keys(response.data.data).map((key) => ({
                        title: key,
                        subheadings: Object.keys(response.data.data[key]) || [],
                    }));
                    setHeadings(dynamicHeadings);
                    if (dynamicHeadings.length > 0) {
                        const firstTitle = dynamicHeadings[0].title;
                        // setOpenSections({ [firstTitle]: true });

                        if (dynamicHeadings[0].subheadings.length > 0) {
                            const firstSubheading = dynamicHeadings[0].subheadings[0];
                            // // handleSelect(firstTitle, firstSubheading);
                            // setupdatedheading(firstTitle);
                            // setupdatedsubheading(firstSubheading);
                        }
                    }

                }
            }
        } catch (err) {
            console.error("Error fetching document:", err);
            setLoading(false)
        }
    };

    useEffect(() => {
        if (projectid) {
            GetDocinfo();
        }
    }, [projectid,]);

    const formatKey = (text) => text.toLowerCase().replace(/\s+/g, "_");

    const subheadingRefs = useRef({});

    const handleSelect = (headingTitle, subheading) => {
        const selectedKey = `${formatKey(headingTitle)}-${formatKey(subheading)}`;
        setSelectedIndex(selectedKey);

        setTimeout(() => {
            subheadingRefs.current[selectedKey]?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 100);
    };


    const handleDownload = async () => {
        try {
            const req = {
                doc_type: doctype,
                project_id: projectid
            };

            const response = await axios.post('/apiV1/download-doc/', req, {
                responseType: 'blob'
            });

            let fileExtension = (doctype === 'doc_exec' || doctype === 'doc_full') ? 'docx' : 'pdf';

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let filename = `downloaded_file.${fileExtension}`;
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+?)"?$/);
                if (match) filename = match[1];
            }

            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };
    const [selectedEditKey, setSelectedEditKey] = useState(null);
    const [editableContent, setEditableContent] = useState("");
    const [successpopup, setsuccesspopup] = useState(false)
    const handleEdit = (headingKey, subheadingKey) => {
        const uniqueKey = `${headingKey}-${subheadingKey}`;
        setSelectedEditKey(uniqueKey);
        setEditableContent(docdata?.[headingKey]?.[subheadingKey]?.result || "No data available");
    };
    // const formatToCamelCase = (str) => {
    //     return str
    //         .replace(/_/g, " ")
    //         .replace(/\w\S*/g, (txt) =>
    //             txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
    //         )
    //         .replace(/\s+/g, " ");
    // };
    const formatToCamelCase = (str) => {
        if (!str) return "";
        const abbreviations = ["ai", "ml", "seo", "faqs", "mvp", "api", "url", "ip",'yc'];

        return str
            .split("_")
            .map(word => {
                const lower = word.toLowerCase();
                if (abbreviations.includes(lower)) {
                    return lower.toUpperCase();
                }
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(" ");
    };

    const handleDocupdate = async () => {
        setLoading(true)
        try {
            let req = {
                doc_type: doctype,
                project_id: projectid,
                document: content
            }
            const response = await axios.post('/apiV1/update-document/', req)
            if (response.status == 200) {
                setLoading(false)
                GetDocinfo()
                setEdit(false)
                setsuccesspopup(true)
                window.location.reload();
            }

        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    }
    const handleSubmit = async (data, heading, subheading) => {
        setLoading(true)

        const fullHTMLContent = `<!DOCTYPE html>
                                    <html lang="en">
                                    <head>
                                        <meta charset="UTF-8">
                                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                    </head>
                                    <body>
                                        ${data}
                                    </body>
                                    </html>`;

        try {
            let req = {
                project_id: projectid,
                document: fullHTMLContent,
                heading: heading,
                sub_heading: subheading,
            }
            const response = await axios.post('/apiV1/update-full-document/', req)
            if (response.status == 200) {
                GetDocinfo()
                setLoading(false)
                setsuccesspopup(true)
            }
        } catch (err) {
            console.log(err);
            setLoading(false)
        }

    }
    const contentRef = useRef(null);
    const handleScroll = () => {
        if (!contentRef.current) return;
        const divs = contentRef.current.querySelectorAll("div[id]");

        for (let div of divs) {
            const rect = div.getBoundingClientRect();
            if (rect.top >= 0 && rect.top <= 150) {
                const divId = div.id;
                const [id1, id2] = divId.split("-");
                setOpenSections((prev) => ({
                    [id1]: true,
                })
                );
                setSelectedIndex(divId);
                break;
            }
        }
    };
    const is_guest = setupdata?.is_guest;
    useEffect(() => {
        if (!is_guest) return;
        const intervalId = setInterval(() => {
            setOpenpopup(true);
        }, 10000);
        return () => clearInterval(intervalId);
    }, [is_guest]);

    
  function extractChartsFromScript(scriptHTML) {
    const chartData = [];

    if (typeof scriptHTML !== "string") {
        console.warn("Script HTML is not a string:", scriptHTML);
        return chartData;
    }

    const scriptBlocks = scriptHTML.match(/<script[^>]*>([\s\S]*?)<\/script>/gi);
    if (!scriptBlocks) return chartData;

    const allScripts = scriptBlocks
        .map(tag => tag.replace(/<\/?script[^>]*>/gi, ""))
        .join("\n");

    const chartRegex = /new Chart\((\w+(?:\.getContext\(['"]2d['"]\))?)\s*,\s*({[\s\S]*?})\);/g;

    let match;
    let matchCount = 0;

    while ((match = chartRegex.exec(allScripts)) !== null) {
        matchCount++;

        let canvasExpr = match[1];
        let chartConfigStr = match[2];

        const canvasVar = canvasExpr.includes(".getContext")
            ? canvasExpr.split(".")[0]
            : canvasExpr;

        const canvasIdMatch = allScripts.match(
            new RegExp(`(?:const|let|var)\\s+${canvasVar}\\s*=\\s*document\\.getElementById\\(['"](.+?)['"]\\)`)
        );
        const canvasId = canvasIdMatch ? canvasIdMatch[1] : canvasVar;

        // ✅ Fix octal literals: replace numbers like 012, 034 etc. with decimal
        chartConfigStr = chartConfigStr.replace(/(?<=\D)0([0-9]{1,})/g, (_, num) => String(parseInt(num, 10)));

        let chartConfig;
        try {
            chartConfig = Function('"use strict"; return (' + chartConfigStr + ')')();
        } catch (err) {
            console.error(`❌ Syntax error in chart config [Match ${matchCount}]:`, err);
            continue;
        }

        try {
            if (
                chartConfig &&
                chartConfig.type &&
                chartConfig.data &&
                chartConfig.data.labels &&
                chartConfig.data.datasets &&
                chartConfig.data.datasets.length > 0
            ) {
                const dataset = chartConfig.data.datasets[0];
                const title =
                    chartConfig.options?.plugins?.title?.display === true
                        ? chartConfig.options.plugins.title.text
                        : '';

                chartData.push({
                    canvasId,
                    type: chartConfig.type,
                    labels: chartConfig.data.labels,
                    dataset: {
                        label: title,
                        data: dataset.data,
                        borderColor: dataset.borderColor,
                        backgroundColor: dataset.backgroundColor,
                        pointBackgroundColor: dataset.pointBackgroundColor,
                        pointBorderColor: dataset.pointBorderColor,
                        borderWidth: dataset.borderWidth,
                        pointRadius: dataset.pointRadius,
                        tension: dataset.tension,
                        fill: dataset.fill,
                    },
                    plugins: chartConfig.options?.plugins || {},
                    scales: chartConfig.options?.scales || {},
                });

                console.log(`✅ Chart ${matchCount} parsed:`, canvasId);
            } else {
                console.warn(`⚠️ Missing required fields in chart config [Match ${matchCount}]:`, match[0]);
            }
        } catch (err) {
            console.error(`❌ Error processing chart [Match ${matchCount}]:`, err);
        }
    }

    console.log("✅ Extracted Chart Data:", chartData);
    return chartData;
}
    
// function extractGoogleCharts(scriptHTML) {
//   const chartData = [];

//   if (typeof scriptHTML !== "string") {
//     console.warn("Script HTML is not a string:", scriptHTML);
//     return chartData;
//   }

//   // Extract <script> content
//   const scriptBlocks = scriptHTML.match(/<script[^>]*>([\s\S]*?)<\/script>/gi);
//   if (!scriptBlocks) return chartData;

//   const allScripts = scriptBlocks
//     .map(tag => tag.replace(/<\/?script[^>]*>/gi, ""))
//     .join("\n");

//   // --- STEP 1: Extract all array variables (const/let/var ...)
//   const varArrayRegex = /\b(?:const|let|var)\s+([A-Za-z0-9_$]+)\s*=\s*(\[[\s\S]*?\]);/g;
//   const arrays = {};
//   let varMatch;
//   while ((varMatch = varArrayRegex.exec(allScripts)) !== null) {
//     arrays[varMatch[1]] = varMatch[2];
//   }

//   // --- STEP 2A: Handle drawPie("id", ...) pattern
//   const drawPieRegex = /drawPie\s*\(\s*['"]([^'"]+)['"]\s*,\s*([^,\)]+)\s*,\s*([^\)]+)\s*\)/g;
//   let match;
//   while ((match = drawPieRegex.exec(allScripts)) !== null) {
//     const containerId = match[1];
//     const dataArg = match[2].trim();
//     const colorsArg = match[3].trim().replace(/;$/, "");

//     const dataArrayText = dataArg.startsWith("[")
//       ? dataArg
//       : arrays[dataArg] || "";
//     const colorArrayText = colorsArg.startsWith("[")
//       ? colorsArg
//       : arrays[colorsArg] || "";

//     const colorMatches = colorArrayText.match(/['"]([^'"]+)['"]/g) || [];
//     const colors = colorMatches.map(s => s.replace(/['"]/g, ""));

//     const rows = [];
//     const rowRegex = /\[\s*['"]([^'"]+)['"]\s*,\s*([0-9.+-eE]+)\s*\]/g;
//     let r;
//     while ((r = rowRegex.exec(dataArrayText)) !== null) {
//       rows.push([r[1], parseFloat(r[2])]);
//     }
//     if (isNaN(rows[0]?.[1])) rows.shift();

//     const labels = rows.map(r => r[0]);
//     const data = rows.map(r => r[1]);
//     if (labels.length)
//       chartData.push({
//         framework: "Google Charts",
//         container: containerId,
//         type: "PieChart",
//         labels,
//         data,
//         colors
//       });
//   }

//   // --- STEP 2B: Handle inline google.visualization.PieChart(...) pattern
//   const inlinePieRegex =
//     /google\.visualization\.PieChart\s*\(\s*document\.getElementById\(['"]([^'"]+)['"]\)\s*\)[\s\S]*?dataArray\s*=\s*(\[[\s\S]*?\])[\s\S]*?chart\.draw\s*\(/g;

//   let inlineMatch;
//   while ((inlineMatch = inlinePieRegex.exec(allScripts)) !== null) {
//     const containerId = inlineMatch[1];
//     const dataArrayText = inlineMatch[2];

//     const rows = [];
//     const rowRegex = /\[\s*['"]([^'"]+)['"]\s*,\s*([0-9.+-eE]+)\s*\]/g;
//     let r;
//     while ((r = rowRegex.exec(dataArrayText)) !== null) {
//       rows.push([r[1], parseFloat(r[2])]);
//     }
//     if (isNaN(rows[0]?.[1])) rows.shift();

//     const labels = rows.map(r => r[0]);
//     const data = rows.map(r => r[1]);
//     const colors =
//       (dataArrayText.match(/#(?:[0-9a-fA-F]{3}){1,2}\b/g) || []).slice(0, rows.length);

//     if (labels.length)
//       chartData.push({
//         framework: "Google Charts",
//         container: containerId,
//         type: "PieChart",
//         labels,
//         data,
//         colors
//       });
//   }

//   return chartData;
// }



useEffect(() => {
    if (!docdata) return;

    // --- Step 1: Flatten docdata into pure HTML string ---
    const gatherHtml = (input) => {
        if (!input) return '';
        if (typeof input === 'string') return input;
        if (Array.isArray(input)) return input.map(gatherHtml).join('\n');
        if (typeof input === 'object') return Object.values(input).map(gatherHtml).join('\n');
        return '';
    };
    const htmlString = gatherHtml(docdata);

    // --- Step 2: Extract chart configurations ---
    const chartScriptMatches = extractChartsFromScript(htmlString);

    // --- Step 3: Helper to render a chart safely ---
    const renderChart = (chartConfig) => {
        const canvasEl = document.getElementById(chartConfig.canvasId);
        if (!canvasEl) return false;

        const ctx = canvasEl.getContext("2d");
        if (!ctx) return false;

        // Destroy previous chart instance if exists
        if (canvasEl._chartInstance) {
            canvasEl._chartInstance.destroy();
        }

        // Create new Chart.js instance
        const chartInstance = new Chart(ctx, {
            type: chartConfig.type,
            data: {
                labels: chartConfig.labels,
                datasets: [chartConfig.dataset],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: "bottom" },
                    title: {
                        display: !!chartConfig.dataset.label,
                        text: chartConfig.dataset.label,
                    },
                },
            },
        });

        // Keep a reference for cleanup
        canvasEl._chartInstance = chartInstance;
        return true;
    };

    // --- Step 4: Retry logic until all charts exist in DOM ---
    const drawChartsWhenReady = (attempt = 0) => {
        const allFound = chartScriptMatches.every(cfg =>
            document.getElementById(cfg.canvasId)
        );

        if (!allFound && attempt < 10) {
            // Retry every 250ms for ~2.5 seconds total
            setTimeout(() => drawChartsWhenReady(attempt + 1), 250);
            return;
        }

        // Draw all available charts
        chartScriptMatches.forEach(cfg => {
            const success = renderChart(cfg);
            if (!success) console.warn("Canvas not ready for ID:", cfg.canvasId);
        });
    };

    // --- Step 5: Start after a short delay (DOM settle) ---
    const timeoutId = setTimeout(() => drawChartsWhenReady(), 300);

    // --- Step 6: Cleanup on unmount or change ---
    return () => {
        clearTimeout(timeoutId);
        chartScriptMatches.forEach(cfg => {
            const canvasEl = document.getElementById(cfg.canvasId);
            if (canvasEl?._chartInstance) {
                canvasEl._chartInstance.destroy();
                delete canvasEl._chartInstance;
            }
        });
    };
}, [docdata, edit]); // 👈 include edit here to redraw charts on edit toggle


 useEffect(() => {
    if (!docdata) return;

    // --- Recursively extract all HTML from docdata ---
    const gatherHtml = (input) => {
      if (!input) return '';
      if (typeof input === 'string') return input;
      if (Array.isArray(input)) return input.map(gatherHtml).join('\n');
      if (typeof input === 'object') return Object.values(input).map(gatherHtml).join('\n');
      return '';
    };
    const htmlString = gatherHtml(docdata);

    // --- Utility: wrapper builder ---
    const makeWrapper = (targetId) => {
      const container =
        document.getElementById(targetId.replace(/^#/, "")) ||
        document.querySelector(targetId);
      if (!container) return { chartDiv: null, legend: null };

      const wrapper = document.createElement('div');
      wrapper.className = 'chart-wrapper';

      const chartDiv = document.createElement('div');
      chartDiv.classList.add('chart-svg');
      chartDiv.setAttribute('contentEditable', 'false'); // prevent edit interference

      const legend = document.createElement('ul');
      legend.className = 'chart-legend';
      legend.setAttribute('contentEditable', 'false'); // prevent edit interference

      wrapper.appendChild(chartDiv);
      wrapper.appendChild(legend);
      container.innerHTML = '';
      container.appendChild(wrapper);

      return { chartDiv, legend };
    };

    // --- Build legend ---
    const buildLegend = (legendEl, labels, values, colors) => {
      if (!legendEl) return;
      legendEl.innerHTML = '';
      const total = values.reduce((a, b) => a + b, 0);
      labels.forEach((lbl, i) => {
        const li = document.createElement('li');
        li.setAttribute('contentEditable', 'false');
        const colorBox = document.createElement('span');
        colorBox.className = 'chart-legend-color';
        colorBox.style.backgroundColor = (colors && colors[i % colors.length]) || '#ccc';
        const pct = total > 0 ? Math.round((values[i] / total) * 100) : 0;
        li.appendChild(colorBox);
        li.appendChild(document.createTextNode(`${lbl} - ${pct}%`));
        legendEl.appendChild(li);
      });
    };

    const extractedCharts = [];

    // Intercept drawPie calls
    window.drawPie = (...args) => {
      const [containerId, dataArray, colors] = args;
      if (!containerId || !dataArray) return;
      extractedCharts.push({
        framework: "Google Charts",
        container: containerId,
        type: "PieChart",
        labels: dataArray.slice(1).map(r => r[0]),
        data: dataArray.slice(1).map(r => r[1]),
        colors: colors || []
      });
    };

    // --- Load and render charts ---
    const ensureLoaderAndDraw = () => {
      const onChartsLoaded = () => {
        if (!window.google || !window.google.visualization) return;

        // Intercept PieChart constructor
        if (!window._patchedPieChart) {
          const OriginalPieChart = window.google.visualization.PieChart;
          window.google.visualization.PieChart = function (chartDiv) {
            const chartInstance = new OriginalPieChart(chartDiv);
            const originalDraw = chartInstance.draw.bind(chartInstance);
            chartInstance.draw = (dataTable, options) => {
              const labels = [];
              const data = [];
              for (let i = 0; i < dataTable.getNumberOfRows(); i++) {
                labels.push(dataTable.getValue(i, 0));
                data.push(dataTable.getValue(i, 1));
              }
              extractedCharts.push({
                framework: "Google Charts",
                container: chartDiv.id,
                type: "PieChart",
                labels,
                data,
                colors: options?.slices ? Object.values(options.slices).map(s => s.color) : []
              });
              originalDraw(dataTable, options);
            };
            return chartInstance;
          };
          window._patchedPieChart = true;
        }
 setTimeout(() => {
        // Execute any <script> tags within docdata safely
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        tempDiv.querySelectorAll('script').forEach(scriptTag => {
          try {
            new Function(scriptTag.innerText)();
          } catch (e) {
            console.warn("Error executing script:", e);
          }
        });

        // Render charts
        // setTimeout(() => {
          extractedCharts.forEach(chart => {
            const { chartDiv, legend } = makeWrapper(chart.container);
            if (!chartDiv) return;
            const dataTable = window.google.visualization.arrayToDataTable([
              ["Label", "Value"],
              ...chart.labels.map((l, i) => [l, chart.data[i]])
            ]);
            const options = {
              is3D: false,
              legend: 'none',
              pieSliceText: 'percentage',
              backgroundColor: 'transparent',
              chartArea: { width: '80%', height: '70%' },
              slices: (chart.colors || []).reduce((acc, c, i) => {
                acc[i] = { color: c };
                return acc;
              }, {})
            };
            const chartObj = new window.google.visualization.PieChart(chartDiv);
            chartObj.draw(dataTable, options);
            buildLegend(legend, chart.labels, chart.data, chart.colors || []);
            window.addEventListener('resize', () => chartObj.draw(dataTable, options));
          });
        // }, 1000);
      },1000)};

      // Load Google Charts if not loaded
      if (window.google && window.google.visualization) {
        onChartsLoaded();
      } else {
        const script = document.createElement('script');
        script.src = 'https://www.gstatic.com/charts/loader.js';
        script.onload = () => {
          window.google.charts.load('current', { packages: ['corechart'] });
          window.google.charts.setOnLoadCallback(onChartsLoaded);
        };
        document.body.appendChild(script);
      }
    };

    ensureLoaderAndDraw();

    return () => {
      window.removeEventListener('resize', () => { });
      delete window.drawPie;
    };
  }, [docdata, edit]);


    return (
        <>
        {/* <style>{`
        table, th, td {
          border: 1px solid black !important;
          border-collapse: collapse !important;
          padding: 8px !important;
        }
      `}</style> */}
            <PageContainer title="SmartInvestorDeck | ViewDocuments">
                <ScheduleDemo showBanner={true} />
                {loading && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100vw",
                            position: "fixed",
                            top: 0,
                            left: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            zIndex: 9999,
                        }}
                    >
                        <BeatLoader color=" #07659c" size={15} />
                    </Box>
                )}
                {doctype !== "doc_full" ? (
                    <> <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0, mb: 2, }}>
                        <Button variant="contained" color="secondary" onClick={() => navigate(`/documents?id=${projectid}&name=${ProjectName}`)} className="button2" sx={{ gap: 1 }}>
                            <IconArrowNarrowLeftDashed />  Back
                        </Button>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            {!edit ? <Button variant="contained" color="primary" onClick={() => setEdit(true)} sx={{ gap: 1 }}>
                                <IconPencil /> Edit
                            </Button>
                                : <Box sx={{ display: "flex", gap: 2 }}>
                                    <Button variant="contained" color="primary" onClick={() => {setEdit(false); window.location.reload();}}>
                                        Cancel
                                    </Button> 
                                    <Button variant="contained" color="primary" className="button2" 
                                        onClick={() => {
                                            handleDocupdate();
                                        }}
>
                                        Save
                                    </Button>
                                </Box>}
                        </Box>
                    </Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                padding: "20px",
                            }}
                        >
                            <Box
                            contentEditable={edit}
                            suppressContentEditableWarning={true}
                            sx={{
                                position: "relative",
                                display: "inline-block",
                                width: doctype === "doc_invest" ? "100%" : "75%",
                                maxWidth: "1560px",
                                border: "1px solid #ccc",
                                borderRadius: "12px",
                                padding: "10px",
                                fontSize: "16px",
                                minHeight: "150px",
                                maxHeight: "78vh",
                                overflowWrap: "break-word",
                                overflowY: "auto",
                                // scrollbarWidth: "none",
                                // msOverflowStyle: "none",
                            }}
                            onBlur={(e) => {
                                const updatedContent = e.currentTarget.innerHTML;

                                const fullHTMLContent = `<!DOCTYPE html>
                                <html lang="en">
                                <head>
                                    <meta charset="UTF-8">
                                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                </head>
                                <body>
                                    ${updatedContent}
                                </body>
                                </html>`;

                                setContent(fullHTMLContent);
                            }}
                            dangerouslySetInnerHTML={{ __html: docdata }}
                        /></Box>
                    </>
                ) : (
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Box sx={{ width: 250, bgcolor: "white", borderRight: "1px solid #ddd", maxHeight: "82vh", overflowY: "auto", scrollbarWidth: "none", p: 1 }}>
                            {/* <Button variant="contained" onClick={handleDownload}>Export</Button>/ */}
                            <Box sx={{ display: "flex", gap: 1, textAlign: "center", color: "#65a61b" }}>
                                <Button variant="contained" color="secondary" onClick={() => navigate(-1)} className="button2" sx={{ gap: 1 }}>
                                    <IconArrowNarrowLeftDashed />  Back
                                </Button>
                            </Box>
                            <List>
                                {headings.map((heading) => (
                                    <React.Fragment key={heading.title}>
                                        <ListItem
                                            button
                                            onClick={() => toggleSection(heading.title)}
                                            sx={{
                                                borderRadius: 2,
                                                fontWeight: "bold",
                                                bgcolor: openSections[heading.title] ? " #71a2cc" : "transparent",
                                                color: openSections[heading.title] ? "#fff" : "#000",
                                                "&:hover": {
                                                    bgcolor: openSections[heading.title] ? "#71a2cc" : "#f4f4f4",
                                                    color: openSections[heading.title] ? "#fff" : "#000",
                                                },
                                            }}
                                        >
                                            {/* <Typography sx={{ flexGrow: 1 }}>{heading.title}</Typography> */}
                                            <Typography sx={{ flexGrow: 1 }}>{formatToCamelCase(heading.title)}</Typography>
                                            {openSections[heading.title] ? <IconChevronUp stroke={1} /> : <IconChevronDown stroke={1} />}
                                        </ListItem>
                                        <Collapse in={openSections[heading.title]} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding sx={{ pl: 2 }}>
                                                {heading.subheadings.map((sub) => {
                                                    const subheadingKey = `${heading.title}-${sub}`;
                                                    return (
                                                        <ListItem
                                                            key={subheadingKey}
                                                            sx={{
                                                                pl: 2,
                                                                color: selectedIndex === subheadingKey ? " #66a321" : "inherit",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleSelect(heading.title, sub)}
                                                        >
                                                            {/* <Typography variant="body2" sx={{ color: selectedIndex === subheadingKey ? "#66a321" : "#000" }}>{sub}</Typography> */}
                                                            <Typography variant="body2" sx={{ color: selectedIndex === subheadingKey ? " #66a321" : "#000" , fontWeight: selectedIndex === subheadingKey ? "bold" : "normal",}}>{formatToCamelCase(sub)}</Typography>

                                                        </ListItem>
                                                    );
                                                })}
                                            </List>
                                        </Collapse>
                                    </React.Fragment>
                                ))}
                            </List>


                        </Box>

                        <Box
                            ref={contentRef}
                            sx={{
                                width: "100%",
                                maxWidth: "1050px",
                                borderRadius: "12px",
                                padding: "10px",
                                fontSize: "16px",
                                minHeight: "150px",
                                maxHeight: "90vh",
                                overflowWrap: "break-word",
                                overflowY: "auto",
                                // scrollbarWidth: "none",
                                // msOverflowStyle: "none",
                                // "&::-webkit-scrollbar": { display: "none" },
                            }}
                            onScroll={handleScroll}
                        >
                            <div>

                                {headings.map((heading) =>

                                    heading.subheadings.map((subheading) => {
                                        const headingKey = formatKey(heading.title);
                                        const subheadingKey = formatKey(subheading);
                                        const uniqueKey = `${headingKey}-${subheadingKey}`;

                                        // Extract raw HTML content
                                        const rawHtmlContent = docdata?.[headingKey]?.[subheadingKey]?.result || "No data available";

                                        return (
                                            <div
                                                key={uniqueKey}
                                                id={uniqueKey}
                                                ref={(el) => (subheadingRefs.current[uniqueKey] = el)}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "start",
                                                    padding: "10px",
                                                    borderRadius: "5px",
                                                    marginBottom: "15px",
                                                    width: "100%",
                                                    maxWidth: "1300px",
                                                }}
                                            // onScroll={(e)=>console.log(e.target)}
                                            >
                                                {/* Heading Key & Buttons in One Row */}
                                                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                                    <h3 style={{ margin: 0, flexGrow: 1 }}>
                                                        {formatToCamelCase(heading.title)} - {formatToCamelCase(subheading)}
                                                    </h3>

                                                    {selectedEditKey === uniqueKey ? (
                                                        <Box sx={{ mb: 1 }}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => setSelectedEditKey(null)}
                                                                style={{ marginLeft: "10px" }}
                                                            >
                                                                Cancel
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className="button2"
                                                                onClick={() => { setSelectedEditKey(null); handleSubmit(editableContent, heading.title, subheading) }}
                                                                style={{ marginLeft: "10px" }}
                                                            >
                                                                Save
                                                            </Button>
                                                        </Box>
                                                    ) : (
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => {
                                                                setEditableContent(rawHtmlContent);
                                                                setSelectedEditKey(uniqueKey);
                                                            }}
                                                            style={{ marginLeft: "10px" }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    )}
                                                </div>

                                                {/* Content - Show editable div in edit mode, plain text otherwise */}
                                                {selectedEditKey === uniqueKey ? (
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            display: "inline-block",
                                                            width: "100%",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "12px",
                                                            padding: "10px",
                                                            fontSize: "16px",
                                                            minHeight: "150px",
                                                            height: "77vh",
                                                            overflowWrap: "break-word",
                                                            overflowY: "auto",
                                                            opacity: loader ? 0.5 : 1,
                                                            pointerEvents: loader ? "none" : "auto",
                                                        }}
                                                        contentEditable={true}
                                                        dangerouslySetInnerHTML={{ __html: editableContent }}
                                                        onBlur={(e) => setEditableContent(e.currentTarget.innerHTML)}
                                                    />
                                                ) : (
                                                    <div dangerouslySetInnerHTML={{ __html: rawHtmlContent }} />
                                                )}
                                            </div>
                                        );
                                    })
                                )}



                            </div>

                        </Box>



                    </Box>
                )}

                {open && (
                    <Box
                        component="form"
                        // onSubmit={handleUpdate}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                            position: "absolute",
                            top: "13%",
                            right: "4%",
                            width: "350px",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                            zIndex: 9,
                        }}
                    >
                        {/* Header */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                Quick Modify
                            </Typography>
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpen(false)}
                                sx={{ color: (theme) => theme.palette.grey[500] }}
                                disabled={loader}
                            >
                                <IconX />
                            </IconButton>
                        </Box>

                        {/* Textarea */}
                        <textarea
                            name="value"
                            value={promptChange}
                            onChange={(e) => setPromptChange(e.target.value)}
                            placeholder="Provide the prompt here for the required changes and customize the document"
                            style={{
                                width: "100%",
                                height: "100px",
                                padding: "8px",
                                fontSize: "16px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                resize: "vertical",
                                outline: "none",
                            }}
                        />

                        {/* Action Buttons */}
                        <Box sx={{ display: "flex", gap: 2, width: "100%", justifyContent: "flex-end" }}>
                            <Button variant="contained" color="primary" onClick={() => setOpen(false)} disabled={loader}>
                                Cancel
                            </Button>
                            <Button type="submit" variant="contained" color="primary" disabled={loader}>
                                {loader ? <BeatLoader size={8} color="#fff" /> : "Update"}
                            </Button>
                        </Box>
                    </Box>
                )}
            </PageContainer>
            <Dialog open={Openpopup} PaperProps={{ sx: { borderRadius: "16px", padding: "10px" } }}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ fontWeight: " bold" }}
                >
                    Upgrade to Unlock
                    <Box />
                    <IconButton size="small" onClick={() => setOpenpopup(false)}>
                        <IconX />
                    </IconButton>
                </Box>
                <Divider />
                <DialogContent>
                    <IconCrown size={50} color="#f5945c" style={{ display: "block", margin: "0 auto 16px" }} />
                    <Typography id="confirm-delete-dialog-description" align="center">
                        You’re currently on a free plan. Please upgrade your account to unlock more features
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 2,
                        marginBottom: 1,
                    }}
                >
                    <Button variant="contained" onClick={() => navigate("/plans")}>Upgrade Now</Button>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{
                            width: 120,
                            borderColor: "#e0e0e0",
                        }}
                        onClick={() => setOpenpopup(false)}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={successpopup} fullWidth maxWidth="md"sx={{maxWidth: "700px", margin: "auto" }}>
          <DialogTitle sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#0e860e",
                  padding: 3,
                  "&:hover": { backgroundColor: "#0e860e" }
                }}
              >
                <IconCheck color="#fff" size={30} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              Document updated successfully.
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { setsuccesspopup(false); }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        </>
    );
};

export default ViewDocuments;
